import type { Language } from '@/i18n/LanguageContext';

const NUMBER_LOCALES: Record<Language, string> = {
  en: 'en-US',
  es: 'es-ES',
};

export function formatLocalizedNumber(
  value: number,
  language: Language,
  options: Intl.NumberFormatOptions = {}
): string {
  return new Intl.NumberFormat(NUMBER_LOCALES[language], {
    useGrouping: false,
    ...options,
  }).format(value);
}

export function formatFixedNumber(
  value: number,
  language: Language,
  fractionDigits: number
): string {
  return formatLocalizedNumber(value, language, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
}
